<template>
  <v-layout justify-center>
    <v-flex>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="users"
          sort-by="displayName"
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <td v-text="props.item.displayName" />
            <td v-text="props.item.email" />
            <td>
              <v-chip v-for="group in props.item.groups" :key="group">{{
                group
              }}</v-chip>
            </td>
            <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="editItem(props.item)"
                v-text="fa('edit')"
              ></v-icon>
              <v-icon
                small
                @click="
                  deleteDialog = true;
                  toDeleteUser = props.item;
                "
                v-text="fa('trash-alt')"
              ></v-icon>
            </td>
          </template>
        </v-data-table>

        <v-btn
          color="primary"
          dark
          class="mb-2"
          absolute
          bottom
          left
          fab
          large
          @click="addUser"
        >
          <v-icon v-text="fa('plus')" dark></v-icon>
        </v-btn>
      </v-card>
    </v-flex>

    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Remove user?</v-card-title>
        <v-card-text>Are you sure you want to remove this user?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            flat
            @click="
              deleteDialog = false;
              toDeleteUser = null;
            "
            >Disagree</v-btn
          >
          <v-btn flat @click="deleteItem">Agree</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="500px">
      <v-form
        v-model="userFormValid"
        lazy-validation
        @submit.prevent
        autocomplete="off"
        ref="form"
      >
        <v-card>
          <v-card-title>
            <span class="headline" v-text="formTitle" />
          </v-card-title>

          <v-card-text v-if="toEditUser">
            <v-text-field
              v-model="toEditUser.displayName"
              :rules="[formRules.required]"
              label="Name"
              required
            />

            <v-text-field
              v-model="toEditUser.email"
              :rules="[formRules.required, formRules.email]"
              label="Email"
              required
              name="email"
              browser-autocomplete="off"
            />

            <v-text-field
              v-model="toEditUser.password"
              :append-icon="fa(showPassword ? 'eye' : 'eye-slash')"
              :rules="toEditUser ? [] : [formRules.required, formRules.min]"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              hint="At least 6 characters"
              counter
              required
              @click:append="showPassword = !showPassword"
              browser-autocomplete="off"
            />

            <v-select
              v-model="toEditUser.groups"
              :items="groups"
              :rules="[formRules.required]"
              attach
              chips
              label="Groups"
              multiple
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn @click="close" :disabled="loading">Cancel</v-btn>
            <v-btn
              color="primary"
              @click="save"
              :disabled="!userFormValid"
              type="input"
              :loading="loading"
              >{{ formTitle }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>

<script>
import { eventHub } from "../config/constants";

export default {
  name: "UserManagement",
  data() {
    return {
      loading: false,
      groups: ["admin", "user"],
      users: [],
      userFormValid: false,
      showPassword: false,
      dialog: false,
      deleteDialog: false,
      toDeleteUser: null,
      toEditUser: null,
      user: {
        displayName: null,
        email: null,
        password: null,
        groups: []
      }
    };
  },
  async created() {
    this.loading = true;
    try {
      const { data } = await this.$functions.httpsCallable("listUsers")();
      this.users = data;
    } catch (error) {
      eventHub.$emit("message", "red", error.message);
    }
    this.loading = false;
  },
  computed: {
    headers: () => [
      {
        text: "Name",
        value: "displayName"
      },
      { text: "Email", value: "email" },
      { text: "Groups", value: "groups" },
      { text: "Actions", value: "action", sortable: false, width: "100px" }
    ],
    formTitle() {
      return this.toEditUser && this.toEditUser.id ? "Edit user" : "New user";
    }
  },
  methods: {
    addUser() {
      this.toEditUser = {
        ...this.user
      };
      this.dialog = true;
    },
    editItem(user) {
      this.toEditUser = {
        ...user
      };
      this.dialog = true;
    },

    async deleteItem() {
      this.loading = true;
      try {
        await this.$functions.httpsCallable("deleteUser")(this.toDeleteUser);
        this.users.splice(this.users.indexOf(this.toDeleteUser), 1);
        this.toDeleteUser = null;
        this.deleteDialog = false;
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.loading = false;
    },

    close() {
      this.dialog = false;
      this.toEditUser = null;
    },

    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        if (this.toEditUser.id) {
          await this.$functions.httpsCallable("updateUser")(this.toEditUser);
          this.users.find(user => user.id === this.toEditUser.id).groups = [
            ...this.toEditUser.groups
          ];
        } else {
          const { data } = await this.$functions.httpsCallable("createUser")(
            this.toEditUser
          );
          this.users.push(data);
        }
      } catch (error) {
        eventHub.$emit("message", "red", error.message);
      }
      this.loading = false;
      this.close();
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  }
};
</script>
